import type { DocumentSummary } from '@/lib/api/types'
import { screenFor, type Screen } from '@/lib/domain/status'

export const SCREEN_PATH = {
  preparing: '/documents/$docId/preparing',
  edit: '/documents/$docId/edit',
  translating: '/documents/$docId/translating',
  review: '/documents/$docId/review',
} as const satisfies Record<Screen, string>

/** Links go straight to the document's screen, so hover-preload fetches the right chunk. */
export function documentPath(doc: Pick<DocumentSummary, 'status' | 'route' | 'failure'>) {
  // A translation runs in the background: the pictures open meanwhile (a failed one shows why).
  return doc.status === 'translating' ? SCREEN_PATH.edit : SCREEN_PATH[screenFor(doc)]
}
